import unloadActivity from "./unload-activity";
import type { SingleSpaEvent } from "typings";

type RouteStateParams = {
  /**
   * `true` permite que o microfrontend seja desmontado;
   * `false` não desmonta.
   */
  unload?: boolean;
};

type BeforeRoutingEvent = SingleSpaEvent<RouteStateParams>;

export function addUnloadAppsEvent() {
  window.addEventListener(
    "single-spa:before-routing-event",
    (evt: BeforeRoutingEvent) => {
      const shouldUnloadApps =
        evt.detail.originalEvent?.state?.unload &&
        evt.detail.oldUrl === evt.detail.newUrl;
      if (shouldUnloadApps) {
        const location = window.location;
        location.href = evt.detail.newUrl;
        unloadActivity(location);
      }
    }
  );
}
